import { chain, overrideWalletAddress, walletAddress, walletConnected } from '$lib/wallet/store';
import { get } from 'svelte/store';
import { smartContractWalletAddress } from '$lib/home/scwallet/store';
export function logSimpleAnalyticsEvent(event: string, properties: any = {}) {
	try {
		if (!get(overrideWalletAddress)) {
			//enrich with metadata
			if (get(walletConnected) && get(walletAddress)) {
				properties.address = get(walletAddress);
				if (get(smartContractWalletAddress)) {
					properties.smartContractWalletAddress = get(smartContractWalletAddress);
				}
				if (get(chain)) {
					properties.chain = get(chain)?.id;
				}
			}
			properties.timestamp = new Date().getTime();
			properties.readable_date = new Date().toUTCString();
			sa_event(event, properties);
		}
	} catch (e) {
		console.log(e);
	}
}

export function logGoogleAnalyticsEvent(event: string, properties: any = {}) {
	try {
		if (!get(overrideWalletAddress)) {
			//enrich with metadata
			if (get(walletConnected) && get(walletAddress)) {
				properties.address = get(walletAddress);
				if (get(smartContractWalletAddress)) {
					properties.smartContractWalletAddress = get(smartContractWalletAddress);
				}
				if (get(chain)) {
					properties.chain = get(chain)?.id;
				}
			}
			properties.timestamp = new Date().getTime();
			properties.readable_date = new Date().toUTCString();
			gtag('event', event, properties);
		}
	} catch (e) {
		console.log(e);
	}
}

export function logAnalytcisEvent(event: string, properties: any = {}) {
	logSimpleAnalyticsEvent(event, properties);
	logGoogleAnalyticsEvent(event, properties);
}
